import request, { METHODS } from "src/utils/api-base";

const adminReportsApis = {
  getSummary: (params?: { days?: number; startDate?: string; endDate?: string }) =>
    request({
      route: "/admin/reports/summary",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    }),
};

export default adminReportsApis;
